export default "__VITE_ASSET__DnYu$GfE__"